import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import Logo from "../../common/assets/images/imdexlogo.png";
import axios from "axios";
import { BiLoader } from "react-icons/bi";
import { NavLink, useLocation } from "react-router-dom";
import ArrowRight from "../../common/assets/svg/ArrowRight";
import { CircleImg } from "../../common/assets/svg/CircleImg";
import { ArrowDown } from "../../common/assets/svg/ArrowDown";
import { Link } from "react-router-dom";
import { useAuth } from "../../authContext/AuthContext";
import notifications from "./notificationsdummy.js";
import { useNavigate } from "react-router-dom";
import settings_icom from '../../../src/assets/settings.svg';
import feedback_icon from '../../../src/assets/person-feedback-svgrepo-com.svg';
import userfeedbacks_icon from '../../../src/assets/userfeedbacks.svg';
import logout_icon from '../../../src/assets/logout.svg';
import { configData, adminConfigData } from "./config";
import admin_icon from '../../../src/assets/admin.svg'

function Navbar({
  setMode,
  mode,
  selectedCompanion,
  setSelectedCompanionState,
}) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { userEmail } = useAuth();
  const permissions = JSON.parse(sessionStorage.getItem("permissions"))
  const adminUser = permissions && permissions.admin
  const [navConfigData, setNavConfigData] = useState(configData)
  const [showAdminConfigData, setShowAdminConfigData] = useState(false)
  const [showNotificationDropwdown, setshowNotificationDropdown] =
    useState(false);
  const dropdownRef = useRef(null);
  const [showAll,setShowAll]=useState(false);
  const navigate=useNavigate();
  const displayedNotifications=showAll?notifications:notifications.slice(0,3);
  const location = useLocation();
 
  let adminRoutes = [
    "/users",
    "/role-management",
    "/module-management",
    "/role-module-permission",
    "/user-role-assignment",
    "/manage-organization",
    "/manage-countries"
  ]
 
  useEffect(()=>{
    if(adminRoutes.includes(location.pathname)){
      setShowAdminConfigData(true);
      document.querySelector(".selected-companion").innerText = "Users"
    }
  },[])

  useEffect(() => {
    const userPermissions = Object.entries(permissions).reduce((acc, [key, value]) => {
      if (typeof value === 'boolean' && value || Array) {
        acc.push(key);}
      return acc;
  }, []);
  // console.log(userPermissions,"=============================================================================" ,typeof(userPermissions));



  const isAdmin = permissions.admin === true;
  // const filteredConfigData = configData.filter(item => {
  //   return userPermissions.includes(item.name);
   
  // });
  const filteredConfigData = isAdmin
  ? configData // If admin, include all config data
  : configData.filter(item => userPermissions.includes(item.name) || item.name === "DiscoverFeatures");

// console.log(filteredConfigData);

  // console.log(filteredConfigData);
  if(showAdminConfigData){
    setNavConfigData(adminConfigData);}else{setNavConfigData(filteredConfigData);}
  }, [showAdminConfigData]);

  
  
  const handleLogoutClick = () => {
  
    setLoading(true);
    const postapiEndpoint = "";
    const accessToken = sessionStorage.getItem("accessToken");
    const postpayload = {
      body: {
        session_token: accessToken,
      },
    };
    // Check if an API endpoint exists (future use case)
    if (postapiEndpoint) {
      // Perform API-based logout
      axios
        .post(postapiEndpoint, postpayload)
        .then((response) => {
          //console.log("Logout request successful:", response);

          // Clear sessionStorage and handle logout
          sessionStorage.clear();
         window.location.reload(); // Or navigate to the login pag
        })
        .catch((error) => {
         //console.log("Error in logout request:", error);
          setError(error.message);
        })
        .finally(() => {
          setLoading(false); // Stop loading spinner
        });
    } else {
      // Manual logout (no API endpoint available)
      //console.log("Manual logout");

      // Clear sessionStorage manually
      sessionStorage.clear();

      // // Update state and reload the app or navigate to the login page
      window.location.reload(); // Optionally use `navigate("/login")` if preferred
     
      setLoading(false);
    }
  };

  const handleCompanionClick = (companion) => {
    setSelectedCompanionState(companion);
  };
  const handleMode = () => {
    const newMode = mode === "DARK" ? "LIGHT" : "DARK";
    setMode(newMode);
    sessionStorage.setItem("mode", newMode);
  };
  const handleNotificationDropdown = () => {
    setshowNotificationDropdown(!showNotificationDropwdown);
  };
  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setshowNotificationDropdown(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
  const handleShowAllNotifications=()=>{
    navigate('/notifications');
    setshowNotificationDropdown(false);
  }
  const handleAdminSettingsClick = () => { setShowAdminConfigData(!showAdminConfigData); };
  return (
    <div className="landingpage-header">
      <div className="landing-header-top">
        <img className="landing-logo" src={Logo} alt="fff" />
        <div className="landing-account-info">
          <div style={{ position: "relative" }} ref={dropdownRef}>
          {/* {(
              <button
                type="button"
                onClick={handleNotificationDropdown}
                className="icon-button me-2"
              >
                <span className="material-icons">notifications</span>
                <span className="icon-button__badge">2</span>
              </button>
            )} */}
            {showNotificationDropwdown && (
              <div className="notification-dropdown">
                <div
                  className="text-center wrapper-div"
                >
                  <h6>Notifications</h6>
                </div>
                <div>
                  {displayedNotifications.map((eachItem,index) => {
                    return (
                      <div key={index}
                        className="each-notification d-flex gap-3"
                      >
                      <div className='initial-notification-userbadge'>{eachItem.username.charAt(0).toUpperCase()}</div>
                       <div>
                         <p className="username-upload">
                          {eachItem.username} uploaded a file
                        </p>
                        <p style={{ fontSize: "12px" }}>
                          {eachItem.dateandtime}
                        </p>
                        </div>
                      </div>
                    );
                  })}
                  {notifications.length>9 && <button className="show-all-notifications-btn" onClick={handleShowAllNotifications}>View All</button>}
                </div>
              </div>
            )}
          </div>
          {/* <NotificationPopup show={showNotificationModal} handleModalClose={handleCloseNotificationModal}/> */}
          {/* <div className="d-flex">
            <span className="mode-color-nav">
              {mode === "DARK" ? "Light Mode" : "Dark Mode"}
            </span>
            <div>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={mode === "DARK"}
                  onChange={handleMode}
                />
                <span className="slider round light"></span>
              </label>
            </div>
          </div> */}
          <span className="landingpage-user-email">{userEmail}</span>
          <CircleImg />
          <div className="landingpage-arrow-down">
            <ArrowDown />
            <div className="landingpage-dropdown-content">
              {/* <div> */}
                {/* <div style={{padding:'8px 8px 0px 12px'}}>
                <Link to="powerapp" onClick={()=>setSelectedCompanionState("Settings")}>
                <img src={settings_icom} alt="settings" style={{height:"25px"}}/>
                  <span className="pb-2">Settings</span>
                </Link>
                </div> */}
                {/* <div style={{padding:'8px 8px 0px 12px'}}>
                  <Link to="feedback" onClick={()=>setSelectedCompanionState("Feedback")}>
                  <img src={feedback_icon} alt="feedback" style={{height:"25px"}}/>
                    <span className="pb-2">Feedback</span>
                  </Link>
                </div> */}
                {/* <div style={{padding:'8px 8px 0px 12px'}}>
                  <Link to="user-feedbacks" onClick={()=>setSelectedCompanionState("User Feedback")}>
                  <img src={userfeedbacks_icon} alt="userfeedbacks" style={{height:"25px"}}/>
                    <span className="pb-2">User Feedback</span>
                  </Link>
                </div> */}
                {/* {adminUser && <div style={{padding:'8px 8px 0px 12px'}}>
                  <Link to={showAdminConfigData?"discover-features":"users"} onClick={handleAdminSettingsClick}>
                  <img src={admin_icon} alt="admin" style={{height:"25px"}}/>
                    <span>{showAdminConfigData? "User Settings" : "Admin Settings"}</span>
                  </Link>
                </div>} */}
                <div onClick={handleLogoutClick}>
             
                <span
                  className="landing-logout-btn"
                >
                 <img src={logout_icon} alt="logout" style={{height:"25px"}}/>
                  {loading ? <BiLoader /> : "Logout"}
                </span>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="landing-header-bottom">
        <div className="selected-companion">Grouper AI</div>
                  
        <ul className="landing-companion-toggle-btn">
          {navConfigData
  .filter((route) => route.header === "Grouper AI")
  .map((route, index) => (
    <li
      key={index}
      onClick={() => handleCompanionClick(route.header)}
    >
      <NavLink to={route.path}>{route.header}</NavLink>
    </li>
  ))}

        </ul>
      </div>
    </div>
  );
}

export default Navbar;
